export default __webpack_public_path__ + "static/media/prizeShake.99516028.png";